import { getApiFilterBuilder, getApiPaging, getApiSort } from '../../../utils/apig02/apig02'
import { get } from 'lodash'
import routeParams from '../../../helpers/routeParams'

const GET_AWARDS_PROGRESS_OVERVIEW = 'dofe-bo/award/GET_AWARDS_PROGRESS_OVERVIEW'
const GET_AWARDS_PROGRESS_OVERVIEW_SUCCESS = 'dofe-bo/award/GET_AWARDS_PROGRESS_OVERVIEW_SUCCESS'
const GET_AWARDS_PROGRESS_OVERVIEW_FAIL = 'dofe-bo/award/GET_AWARDS_PROGRESS_OVERVIEW_FAIL'

const GET_AWARDS_PROGRESS_OVERVIEW_COUNT = 'dofe-bo/award/GET_AWARDS_PROGRESS_COUNT_OVERVIEW'
const GET_AWARDS_PROGRESS_OVERVIEW_COUNT_SUCCESS = 'dofe-bo/award/GET_AWARDS_PROGRESS_OVERVIEW_COUNT_SUCCESS'
const GET_AWARDS_PROGRESS_OVERVIEW_COUNT_FAIL = 'dofe-bo/award/GET_AWARDS_PROGRESS_OVERVIEW_COUNT_FAIL'

const SET_AWARDS_PROGRESS_OVERVIEW_FILTER = 'dofe-bo/award/SET_AWARDS_PROGRESS_OVERVIEW_FILTER'
const SET_AWARDS_PROGRESS_OVERVIEW_PARAMS = 'dofe-bo/award/SET_AWARDS_PROGRESS_OVERVIEW_PARAMS'

const EXPORT_AWARD_PROGRESS_OVERVIEW = 'dofe-bo/award/EXPORT_AWARD_PROGRESS_OVERVIEW'
const EXPORT_AWARD_PROGRESS_OVERVIEW_SUCCESS = 'dofe-bo/award/EXPORT_AWARD_PROGRESS_OVERVIEW_SUCCESS'
const EXPORT_AWARD_PROGRESS_OVERVIEW_FAIL = 'dofe-bo/award/EXPORT_AWARD_PROGRESS_OVERVIEW_FAIL'

const initialState = {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    loading: false,
    loaded: false
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_AWARDS_PROGRESS_OVERVIEW:
            return {
                ...state,
                loading: true
            }
        case GET_AWARDS_PROGRESS_OVERVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                list: action.result.list
            }
        case GET_AWARDS_PROGRESS_OVERVIEW_FAIL:
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.error
            }
      case GET_AWARDS_PROGRESS_OVERVIEW_COUNT:
        return {
          ...state,
          countLoaded: false,
          countLoading: true
        }
      case GET_AWARDS_PROGRESS_OVERVIEW_COUNT_SUCCESS:
        const totalCount = Number(get(action.result, 'totalCount') || 0)
        return {
          ...state,
          countLoading: false,
          countLoaded: true,
          count: totalCount,
          pages:
            Math.ceil(totalCount / state.limit) ||
            state.pages
        }
      case GET_AWARDS_PROGRESS_OVERVIEW_COUNT_FAIL:
        return {
          ...state,
          loading: false,
          loaded: false,
          error: action.error
        }
      case SET_AWARDS_PROGRESS_OVERVIEW_FILTER:
        return {
          ...state,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      case SET_AWARDS_PROGRESS_OVERVIEW_PARAMS:
        return {
          ...state,
          limit:
            action.options.limit !== undefined
              ? action.options.limit
              : state.limit,
          offset:
            action.options.offset !== undefined
              ? action.options.offset
              : state.offset,
          filter:
            action.options.filter !== undefined
              ? action.options.filter
              : state.filter,
          sort:
            action.options.sort !== undefined ? action.options.sort : state.sort
        }
        default:
            return state
    }
}


export function setAwardsProgressOverviewFilter(filterBy) {
  return {
    type: SET_AWARDS_PROGRESS_OVERVIEW_FILTER,
    filterBy
  }
}

export function setAwardsProgressOverviewParams(options) {
  return {
    type: SET_AWARDS_PROGRESS_OVERVIEW_PARAMS,
    options
  }
}

export function getAwardsProgressOverview(params = {}) {
  return {
    types: [
      GET_AWARDS_PROGRESS_OVERVIEW,
      GET_AWARDS_PROGRESS_OVERVIEW_SUCCESS,
      GET_AWARDS_PROGRESS_OVERVIEW_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/participant/overview/progress/list`, {
          data: {
            sort: getApiSort(params.sort),
            filter: buildAwardOverviewFilter(params),
            paging: getApiPaging(params.offset, params.limit),
            options: {
              getRecordList: true,
              getTotalCount: false
            }
          }
        }
      )
  }
}


export function getAwardsProgressOverviewCount(params = {}) {
  return {
    types: [
      GET_AWARDS_PROGRESS_OVERVIEW_COUNT,
      GET_AWARDS_PROGRESS_OVERVIEW_COUNT_SUCCESS,
      GET_AWARDS_PROGRESS_OVERVIEW_COUNT_FAIL
    ],
    promise: client =>
      client.post(
        `apiv2/participant/overview/progress/list`, {
          data: {
            filter: buildAwardOverviewFilter(params),
            options: {
              getRecordList: false,
              getTotalCount: true
            }
          }
        }
      )
  }
}

export function exportAwardProgressOverview(params = {}) {
  return {
    types: [EXPORT_AWARD_PROGRESS_OVERVIEW, EXPORT_AWARD_PROGRESS_OVERVIEW_SUCCESS, EXPORT_AWARD_PROGRESS_OVERVIEW_FAIL],
    promise: client =>
      client.post(
        `apiv2/participant/overview/progress/list`, {
          data: {
            sort: getApiSort(params.sort),
            filter: buildAwardOverviewFilter(params),
            options: {
              getRecordList: true,
              getTotalCount: false
            }
          }
        }
      )
  }
}

function buildAwardOverviewFilter(params) {
  const filterBuilder = getApiFilterBuilder(params.filter)
    .named('search@like', 'search')
    .parse('awardLevel@in', 'award.level', i => i.value)
    .parse('personState@eq', 'participant.state')
    .parse('awardState@in', 'award.state', i => i.value)
    .parse('awardLeader@in', 'awardLeaderId', i => i.value)
    .parse('awardOrganization@in', 'award.organization.id', i => i.value)
    .parse('personLabel@in', 'participant.labelList.label.id', i => i.value)
    .parse('awardLabel@in', 'award.labelList.label.id', i => i.value)

  return filterBuilder.build()
}


